var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_3021",
    "data-name": "Groupe 3021",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44.111,
    height: 44.62,
    viewBox: "0 0 44.111 44.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_241",
    "data-name": "Rectangle 241",
    width: 44.111,
    height: 44.62,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3017",
    "data-name": "Groupe 3017",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36688",
    "data-name": "Trac\\xE9 36688",
    d: "M37.681,10.748a.48.48,0,0,1,.479.479v26.7a.48.48,0,0,1-.479.479h-26.7a.48.48,0,0,1-.48-.479v-26.7a.48.48,0,0,1,.48-.479Zm0-.748h-26.7A1.227,1.227,0,0,0,9.75,11.227v26.7a1.227,1.227,0,0,0,1.228,1.227h26.7a1.227,1.227,0,0,0,1.227-1.227v-26.7A1.227,1.227,0,0,0,37.681,10",
    transform: "translate(-2.46 -2.524)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36689",
    "data-name": "Trac\\xE9 36689",
    d: "M56.981,17.991A2.991,2.991,0,1,1,53.991,15a2.991,2.991,0,0,1,2.991,2.991",
    transform: "translate(-12.87 -3.786)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36690",
    "data-name": "Trac\\xE9 36690",
    d: "M56.981,26.991A2.991,2.991,0,1,1,53.991,24a2.991,2.991,0,0,1,2.991,2.991",
    transform: "translate(-12.87 -6.057)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36691",
    "data-name": "Trac\\xE9 36691",
    d: "M56.981,35.991A2.991,2.991,0,1,1,53.991,33a2.991,2.991,0,0,1,2.991,2.991",
    transform: "translate(-12.87 -8.328)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36692",
    "data-name": "Trac\\xE9 36692",
    d: "M5.981,17.991A2.991,2.991,0,1,1,2.991,15a2.991,2.991,0,0,1,2.991,2.991",
    transform: "translate(0 -3.786)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36693",
    "data-name": "Trac\\xE9 36693",
    d: "M5.981,26.991A2.991,2.991,0,1,1,2.991,24a2.991,2.991,0,0,1,2.991,2.991",
    transform: "translate(0 -6.057)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36694",
    "data-name": "Trac\\xE9 36694",
    d: "M5.981,35.991A2.991,2.991,0,1,1,2.991,33a2.991,2.991,0,0,1,2.991,2.991",
    transform: "translate(0 -8.328)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36695",
    "data-name": "Trac\\xE9 36695",
    d: "M19.241,0A2.991,2.991,0,1,1,16.25,2.991,2.991,2.991,0,0,1,19.241,0",
    transform: "translate(-4.101 0)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36696",
    "data-name": "Trac\\xE9 36696",
    d: "M28.241,0A2.991,2.991,0,1,1,25.25,2.991,2.991,2.991,0,0,1,28.241,0",
    transform: "translate(-6.372 0)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36697",
    "data-name": "Trac\\xE9 36697",
    d: "M37.241,0A2.991,2.991,0,1,1,34.25,2.991,2.991,2.991,0,0,1,37.241,0",
    transform: "translate(-8.643 0)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36698",
    "data-name": "Trac\\xE9 36698",
    d: "M18.991,51.681A2.991,2.991,0,1,1,16,54.672a2.991,2.991,0,0,1,2.991-2.991",
    transform: "translate(-4.038 -13.042)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36699",
    "data-name": "Trac\\xE9 36699",
    d: "M27.991,51.681A2.991,2.991,0,1,1,25,54.672a2.991,2.991,0,0,1,2.991-2.991",
    transform: "translate(-6.309 -13.042)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36700",
    "data-name": "Trac\\xE9 36700",
    d: "M36.991,51.681A2.991,2.991,0,1,1,34,54.672a2.991,2.991,0,0,1,2.991-2.991",
    transform: "translate(-8.58 -13.042)",
    fill: "#cea95a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg12);
export default __webpack_public_path__ + "static/media/12.f1faf4330198e97dc92fae3fa67d1473.svg";
export { ForwardRef as ReactComponent };